import { Component, OnInit } from '@angular/core';
import { ManageTemplateWrapper } from './manage-template-wrapper';
import { resourceTemplateReselector } from '../../store/reselectors/entity.reselector';
import { JoiResource } from 'globals/store/resources.data';
import { ManageWrapperComponent } from 'src/app/modules/manage/manage-wrapper.component';
import { CommonModule } from '@angular/common';
import { ImageUploaderComponent } from '../wrappers/image-uploader.component';
import { JoiInputComponent } from '../joi-input/joi-input.component';
import { ManageSocialLinksComponent } from 'src/app/modules/manage/manage-social.component';
import { ResourceContactListComponent } from 'src/app/modules/resources/resource-contact-list.component';

@Component({
    selector: 'manage-template-resource',
    templateUrl: './manage-template-resource.html',
    styleUrls: ['../../modules/manage/manage-dialogs.scss'],
    standalone: true,
    imports: [ManageWrapperComponent, CommonModule, ImageUploaderComponent, JoiInputComponent, ManageSocialLinksComponent, ResourceContactListComponent],
})
export class ManageTemplateResource extends ManageTemplateWrapper<JoiResource> implements OnInit {
  _file = 'manage-template-resources'

  ngOnInit() {
    this.clipboardKey = 'resources'
    this.selectProp(resourceTemplateReselector, { id: this.data.entityId, accountId: this.data.accountId}, 'entity')
  }

}
